import { IResultNotificationListDAO } from '../Modules/Notification/DAO/notification.dao';
import instance from '../Services/interceptor';

export const getNotificationListAPI = async (): Promise<
  IResultNotificationListDAO[]
> => {
  const { data } = await instance.get(`/configuration/notification`);
  return data;
};
